import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function TarGzipCompression() {
    return (
        <div className={globalStyles.article}>
            <h1>tar &amp; compression cheat sheet</h1>

            <p><b>tar</b> bundles files into a single archive; it doesn't compress on its own, but can pipe the
                result through a compressor in one command.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">tar flags</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>-c</b></td>
                        <td>Create an archive</td>
                    </tr>
                    <tr>
                        <td><b>-x</b></td>
                        <td>Extract an archive</td>
                    </tr>
                    <tr>
                        <td><b>-t</b></td>
                        <td>List contents without extracting</td>
                    </tr>
                    <tr>
                        <td><b>-v</b></td>
                        <td>Verbose — print each file processed</td>
                    </tr>
                    <tr>
                        <td><b>-f</b></td>
                        <td>Filename follows — almost always the last flag</td>
                    </tr>
                    <tr>
                        <td><b>-z</b></td>
                        <td>gzip (.tar.gz / .tgz) — fast, decent ratio</td>
                    </tr>
                    <tr>
                        <td><b>-j</b></td>
                        <td>bzip2 (.tar.bz2) — slower, better ratio</td>
                    </tr>
                    <tr>
                        <td><b>-J</b></td>
                        <td>xz (.tar.xz) — slowest, best ratio</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Creating archives</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> tar -czvf backup.tar.gz /var/www/app<br/>
    <b>user@host:~$</b> tar -cJvf backup.tar.xz /var/www/app <i># smaller, slower to create</i><br/>
    <b>user@host:~$</b> tar -czvf backup.tar.gz --exclude='node_modules' /var/www/app<br/>
            </pre>

            <h3>Extracting</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> tar -xzvf backup.tar.gz <i># extract into current dir</i><br/>
    <b>user@host:~$</b> tar -xzvf backup.tar.gz -C /restore/path <i># extract elsewhere</i><br/>
    <b>user@host:~$</b> tar -tzvf backup.tar.gz <i># list contents first, without extracting</i><br/>
            </pre>

            <h3>Compressing single files</h3>
            <p>Use gzip/bzip2/xz directly when there's no need to bundle multiple files — they compress in
                place and add their extension.</p>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> gzip access.log <i># produces access.log.gz, removes original</i><br/>
    <b>user@host:~$</b> gzip -k access.log <i># -k keeps the original file too</i><br/>
    <b>user@host:~$</b> gunzip access.log.gz <i># decompress</i><br/>
    <b>user@host:~$</b> zcat access.log.gz | grep ERROR <i># read without decompressing to disk</i><br/>
            </pre>
        </div>
    )
}
